import { useCallback } from 'react';

//services
import { deleteNotes } from 'services/notes';

//icons
import CloseSvg from '../../assets/md-close.svg';
import CheckIcon from '../../assets/check_icon.svg';

//recoil
import { useSetRecoilState } from 'recoil';
import { toastState } from 'recoil/ToastAtom';
import { notesStatusAtom } from 'recoil/NotesStatusAtom';

export const useDeleteNote = () => {
  const setToast = useSetRecoilState(toastState);
  const setNotesStatus = useSetRecoilState(notesStatusAtom);

  const handleDeleteNote = useCallback(
    async (idExcercise: number, idNote: number) => {
      try {
        const status = await deleteNotes(idExcercise, idNote);

        if (status === 200) {
          setNotesStatus(status);
          setToast({
            isOpen: true,
            color: 'success',
            message: 'Borraste la nota',
            icon: CheckIcon,
            button: [
              {
                icon: CloseSvg,
                side: 'end',
                role: 'cancel',
                cssClass: 'toast-button',
              },
            ],
          });
        }
      } catch (e) {
        console.log(e, 'error');
      }
    },
    [setToast, setNotesStatus]
  );

  return { handleDeleteNote };
};
